// src/components/checkout/OrderConfirmation.js
import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Divider,
  CircularProgress
} from '@mui/material';

const OrderConfirmation = ({
  cartItems,
  totalAmount,
  shippingPrice,
  finalTotal,
  orderData,
  shippingPrices,
  selectedGovernorate,
  paymentMethod,
  paymentScreenshot,
  loading,
  cartCount,
  handleSubmit,
  onBack
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
        تأكيد الطلب
      </Typography>

      {/* Order Summary */}
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          mb: 3,
          borderRadius: 2,
          backgroundColor: 'grey.50'
        }}
      >
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
          ملخص الطلب
        </Typography>
        {cartItems.map((item) => (
          <Box 
            key={`${item.id}-${item.colorId}-${item.size}`} 
            sx={{ mb: 1, display: 'flex', justifyContent: 'space-between' }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              {item.name_ar || item.name} {item.size && `- مقاس ${item.size}`} {item.colorName && `- ${item.colorName}`} (×{item.quantity})
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              {(item.price * item.quantity).toFixed(2)} جنيه
            </Typography>
          </Box>
        ))}
        <Divider sx={{ my: 1 }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            إجمالي المنتجات:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            {totalAmount.toFixed(2)} جنيه
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            رسوم الشحن:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            {shippingPrice.toFixed(2)} جنيه
          </Typography>
        </Box>
        <Divider sx={{ my: 1 }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            الإجمالي النهائي:
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            {finalTotal.toFixed(2)} جنيه
          </Typography>
        </Box>
      </Paper>

      {/* Delivery Information */}
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          mb: 3,
          borderRadius: 2,
          backgroundColor: 'grey.50'
        }}
      >
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
          معلومات التوصيل
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography variant="body2">
            <strong>الاسم:</strong> {orderData.fullName}
          </Typography>
          <Typography variant="body2">
            <strong>رقم الهاتف:</strong> {orderData.phone}
          </Typography>
          <Typography variant="body2">
            <strong>العنوان:</strong> {orderData.address}
          </Typography>
          <Typography variant="body2">
            <strong>المحافظة:</strong> {shippingPrices.find(price => price.id === selectedGovernorate)?.governorate_name_ar || ''}
          </Typography>
          {orderData.additionalNotes && (
            <Typography variant="body2">
              <strong>ملاحظات إضافية:</strong> {orderData.additionalNotes}
            </Typography>
          )}
        </Box>
      </Paper>

      {/* Payment Method */}
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          mb: 3,
          borderRadius: 2,
          backgroundColor: 'grey.50'
        }}
      >
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
          طريقة الدفع
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          {paymentMethod === 'vodafone_cash' ? 'فودافون كاش' : 'الدفع عند الاستلام'}
        </Typography>
        {paymentMethod === 'vodafone_cash' && paymentScreenshot && (
          <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
            تم رفع صورة الإيصال
          </Typography>
        )}
      </Paper>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
        <Button onClick={onBack} sx={{ mt: 1, mr: 1, fontWeight: 'bold' }}>
          رجوع
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading || cartCount === 0}
          sx={{ mt: 1, ml: 1, fontWeight: 'bold' }}
        >
          {loading ? <CircularProgress size={24} /> : 'تأكيد الطلب'}
        </Button>
      </Box>
    </Box>
  );
};

export default OrderConfirmation;